import React, { useEffect, useState } from 'react';
import { KeenIcon } from '@/components';
import { ColorInput } from '@/components/ui/input/ColorInput';

const DEFAULT_FILL = '#FFFFFF';
const DEFAULT_STROKE = '#000000';

const AgentAdvancedSettings = ({ onBack, fill = DEFAULT_FILL, stroke = DEFAULT_STROKE, onChange }) => {
  const [currentFill, setCurrentFill] = useState(fill);
  const [currentStroke, setCurrentStroke] = useState(stroke);
  const [hasChanges, setHasChanges] = useState(false);

  useEffect(() => {
    setCurrentFill(fill);
    setCurrentStroke(stroke);
  }, [fill, stroke]);

  const handleFillChange = (newFill) => {
    setCurrentFill(newFill);
    setHasChanges(true);
    onChange?.({ fill: newFill, stroke: currentStroke });
  };

  const handleStrokeChange = (newStroke) => {
    setCurrentStroke(newStroke);
    setHasChanges(true);
    onChange?.({ fill: currentFill, stroke: newStroke });
  };

  const handleReset = () => {
    setCurrentFill(DEFAULT_FILL);
    setCurrentStroke(DEFAULT_STROKE);
    onChange?.({ fill: DEFAULT_FILL, stroke: DEFAULT_STROKE });
    setHasChanges(false);
  };

  const handleSave = () => {
    onChange?.({ fill: currentFill, stroke: currentStroke });
    setHasChanges(false);
  };

  const handleTextChange = (e) => {
    const val = e.target.value.replace(/[^0-9a-fA-F]/g, '').slice(0, 6);
    setCurrentFill(val);
    setHasChanges(true);
    onChange?.({ fill: val, stroke: currentStroke });
  };

  return (
    <div className="p-2">
      {/* Nút quay lại và tiêu đề */}
      <div className="flex items-center mb-8">
        <button onClick={onBack} className="mr-2 flex items-center">
          <KeenIcon icon="arrow-left" className="text-lg" />
        </button>
        <span className="font-bold text-lg">Advanced Settings</span>
      </div>

      {/* Row: Typography */}
      <div className="mb-8">
        <label className="block font-semibold mb-5">Typography</label>
        <div className="grid grid-cols-5 gap-4">
          <select className="border col-span-2 rounded py-2">
            <option>Tahoma</option>
            <option>Arial</option>
            <option>Roboto</option>
          </select>
          <select className="border col-span-2 rounded py-2">
            <option>Bold</option>
            <option>Normal</option>
          </select>
          <select className="border col-span-1 rounded py-2">
            <option>16</option>
            <option>14</option>
            <option>18</option>
          </select>
        </div>
      </div>

      {/* Row: Fill & Stroke */}
      <div className="mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ColorInput label="Fill" value={currentFill} onChange={handleFillChange} className="pr-3"/>
          <ColorInput label="Stroke" value={currentStroke} onChange={handleStrokeChange} />
        </div>
      </div>

      {/* Row: Icon */}
      <div className="mb-8 grid grid-cols-3">
        <div className="col-span-2 grid grid-cols-3 gap-4 text-2xl">
          <div className='flex items-center gap-2 justify-center'>
            <KeenIcon icon="heart" className="text-red-700" />
            <input type="checkbox" checked readOnly />
          </div>
          <div className='flex items-center gap-2 justify-center'>
            <KeenIcon icon="dislike" className="text-blue-700" />
            <input type="checkbox" checked readOnly />
          </div>
          <div className='flex items-center gap-2 justify-center'>
            <KeenIcon icon="copy" />
            <input type="checkbox" checked readOnly />
          </div>
        </div>
      </div>

      {/* Row: Button */}
      <div className="flex gap-4 mt-4 justify-center grid grid-cols-3">
        <button 
          onClick={handleReset}
          className="bg-gray-100 text-gray-500 px-6 py-2 rounded font-bold col-span-1 flex items-center justify-center"
        >
          Default
        </button>
        <button 
          onClick={handleSave}
          className={`text-white px-6 py-2 rounded font-bold col-span-2 flex items-center justify-center gap-2 ${
            hasChanges ? 'bg-[#00B14F]' : 'bg-gray-400'
          }`}
        >
          <KeenIcon icon="save-2" />
          {hasChanges ? 'Save Changes' : 'Saved'}
        </button>
      </div>
    </div>
  );
};

export { AgentAdvancedSettings };
